import React from 'react';
import BubbleEllipsis from '@/pages/datalab/components/BubbleEllipsis';
import './index.scss';

interface ISingleBigNumberProps {
  content?: React.ReactNode;
}

const SingleBigNumber: React.FC<ISingleBigNumberProps> = ({ content }) => {
  return (
    <BubbleEllipsis
      content={content}
      ellipsisClassName="dbl-big-number-content"
    />
  );
};

export default SingleBigNumber;